import React from 'react'


const AgronomyReports = (props) => {

    const createStartOfDay=()=>{


        const date=document.getElementById("sale_date").value
        const exchange_rate=document.getElementById("exchange_rate").value


        const requestOptions = {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({
                description:date,
                amount:exchange_rate,
                userid: 1,
                created_at:"06-08-2024"
            })
        };


        fetch('http://'+props.id_address+'/king/api/create_start_of_day.php', requestOptions)
            .then(response => response.json())
            .then(data => {
                console.log(data[0].response,"Success")

            });

    }


  return (
    <div>
      <a href="/home">
              <i className='bi bi-house-door'></i>
            </a>

            <h4 className='bi bi-home' style={{ color: '#fff' }}>Agronomy Reports</h4>
        <br/>
     {/*<div>*/}
     {/*   <nav class="navbar navbar-expand-lg navbar-light bg-light card_2">*/}
     {/*       <div class="container-fluid">*/}
     {/*           /!* <a href="#" class="navbar-brand">Brand</a> *!/*/}
     {/*           <button type="button" class="navbar-toggler" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">*/}
     {/*               <span class="navbar-toggler-icon"></span>*/}
     {/*           </button>*/}
     {/*           <div class="collapse navbar-collapse justify-content-between" id="navbarCollapse">*/}
     {/*               <div class="navbar-nav">*/}
     {/*                   <a href="" class="nav-item nav-link active" data-bs-toggle="modal" data-bs-target="#example">Start off Day</a>*/}
     {/*                   /!* <a href="" class="nav-item nav-link" data-bs-toggle="modal" data-bs-target="#example2">Statutory Parameters</a>*/}
     {/*                   <a href="" class="nav-item nav-link" data-bs-toggle="modal" data-bs-target="#example3">Deduction Priorities</a>*/}
     {/*                   <a href="" class="nav-item nav-link" data-bs-toggle="modal" data-bs-target="#example4">Sale Parameters</a> *!/*/}
     {/*               </div>*/}
     {/*           </div>*/}
     {/*       </div>*/}
     {/*   </nav>*/}
     {/* </div>*/}

      <br />
      <br />
        <div className="row">
            <div className='col-sm-6 mb-3'>
                <div className="card_2">
                    <div className="card-body">
                        <h5 className="card-title" style={{alignItems:'center'}}>Agronomy Statistics</h5>
                        <br/>
                        <div className="row">
                            <div className="col">
                                <label>Start Date</label>
                                <input type="date"  className="form-control" id="start_day" placeholder="Start Date" />
                            </div>
                            <div className="col">
                                <label>End Date</label>
                                <input type="date"  className="form-control" id="end_day" placeholder="End Date" />
                            </div>
                        </div>
                        <br/>
                        <div className="col-auto">
                            <select className="form-select">
                                <option value=''>Select Statistics Report</option>
                                <option value=''>Combined</option>
                                <option value=''>Farm Visits</option>
                                <option value=''>Performance</option>
                                <option value=''>Tasks</option>
                                <option value=''>Standings</option>
                            </select>
                        </div>
                        <br/>
                        <div className="col-auto">
                            <button className="btn btn-primary">Generate Report</button>
                        </div>

                    </div>
                </div>


            </div>
            <div className='card_2 col-sm-6 mb-3'>
                <div className="card-body">
                        <h5 className="card-title">Agronomy Performance Reports</h5>
                    <br/>
                    <div className="row">
                        <div className="col">
                            <label>Start Date</label>
                            <input type="date"  className="form-control" id="start_day" placeholder="Start Date" />
                        </div>
                        <div className="col">
                            <label>End Date</label>
                            <input type="date"  className="form-control" id="end_day" placeholder="End Date" />
                        </div>
                    </div>
                    <br/>
                    <div className="col-auto">
                        <select className="form-select">
                            <option value=''>Select Report</option>
                            <option value=''>Task</option>
                            <option value=''>Performance</option>
                            <option value=''>Scoreboard</option>
                            <option value=''>Questionnaire</option>
                            <option value=''>Seasonal Standings</option>
                            <option value=''>Bales Collected</option>
                            <option value=''>Deliveries</option>
                        </select>
                    </div>
                    <br/>
                    <div className="col-auto">
                        <button className="btn btn-primary">Generate Report</button>
                    </div>


                </div>

            </div>

        </div>

        <br/>

        <div className="row">
            <div className='col-sm-6 mb-3'>
                <div className="card_2">
                    <div className="card-body">
                        <h5 className="card-title" style={{alignItems:'center'}}>Field Officer Reports</h5>
                        <br/>
                        <div className="row">
                            <div className="col">
                                <label>Start Date</label>
                                <input type="date"  className="form-control" id="start_day" placeholder="Start Date" />
                            </div>
                            <div className="col">
                                <label>End Date</label>
                                <input type="date"  className="form-control" id="end_day" placeholder="End Date" />
                            </div>
                        </div>
                        <br/>
                        <div className="row">
                            <div className="col">
                                <select className="form-select">
                                    <option value=''>Select Field Officer</option>
                                        <option value=''>All</option>
                                    <option value=''>Tinashe Banda</option>
                                    <option value=''>Fine Bande</option>
                                    <option value=''>Scott Sakupwanya</option>
                                    <option value=''>Ishe Madzoro</option>
                                </select>
                            </div>
                            <div className="col">
                                <select className="form-select">
                                    <option value=''>Select Report</option>
                                    <option value=''>Assessment</option>
                                    <option value=''>Tasks</option>
                                    <option value=''>Growers</option>
                                    <option value=''>Performance</option>
                                    <option value=''>Overview</option>
                                </select>
                            </div>
                        </div>

                        <br/>
                        <div className="col-auto">
                            <button className="btn btn-primary">Generate Report</button>
                        </div>

                    </div>
                </div>


            </div>
            <div className='card_2 col-sm-6 mb-3'>
                <div className="card-body">
                    <h5 className="card-title">Grower Assessment</h5>
                    <br/>
                    <div className="row">
                        <div className="col">
                            <label>Start Date</label>
                            <input type="date"  className="form-control" id="start_day" placeholder="Start Date" />
                        </div>
                        <div className="col">
                            <label>End Date</label>
                            <input type="date"  className="form-control" id="end_day" placeholder="End Date" />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col">
                            <select className="form-select">
                                <option value=''>Select Field Officer</option>
                                <option value=''>All</option>
                                <option value=''>Tinashe Banda</option>
                                <option value=''>Fine Bande</option>
                                <option value=''>Scott Sakupwanya</option>
                                <option value=''>Ishe Madzoro</option>
                            </select>
                        </div>
                        <div className="col">
                            <select className="form-select">
                                <option value=''>Select Grower</option>
                                <option value=''>All</option>
                                <option value=''>V123456</option>
                                <option value=''>V124569</option>
                                <option value=''>V5698548</option>
                                <option value=''>V145236</option>
                            </select>
                        </div>
                    </div>
                    <br/>
                    <div className="col">
                        <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#example">Generate Report</button>
                    </div>
                </div>

            </div>

        </div>


      {/* Modals */}

      <div className="modal fade" id="example" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl">
                <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Assessment Preview</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body form-group">
                    <table className="table table-hover">

                    </table>

                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                    <button type="button" class="btn btn-primary" onClick={createStartOfDay}>Submit</button>
                </div>
                </div>
            </div>
      </div>
     
    </div>
  )
}

export default AgronomyReports;